<template>
  <div class="notifications-base section">
    <div class="message-body" :class="{ open: messEnable }" v-if="newsList.length > 0">
      <div
        class="message"
        v-for="(item, idx) in newsList"
        @click="onNewsItemClick(item.id)"
        :key="idx"
      >
        <span v-if="item.readed === 0" class="lbl-new">NEW</span>
         {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: "Notifications",
  data() {
    return {
      messEnable: false,
      firstOpen: false
    }
  },
  props: {
    message: {
      type: String,
      default(){
        return ''
      }
    },
    openMess: {
      type: Boolean,
      default() {
        return false
      }
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    newsList: {
      type: Array,
      default(){
        return []
      }
    }
  },
  watch: {
    openMess(val) {
      if(this.firstOpen) {
        if (val) {
          this.messEnable = true
        } else {
          this.messEnable = false
        }
      }
    },
    scroll: {
      handler(val){
        if(!!val && this.firstOpen){
          if(val.top > 100) {
            this.messEnable = false
          }else{
            this.messEnable = true
          }
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      scroll: states => states.uiState.scroll
    }),
    newsListMod() {
      return [this.newsList[0]]
    }
  },
  created() {
    if(!!this.message && this.message.length > 0) {
      this.$emit('set-notification')
    }
  },
  mounted() {
    if(!!this.message && this.message.length > 0) {
      setTimeout(() => {
        this.firstOpen = true
        this.messEnable = true
      }, 2000)
    }
  },
  methods: {
    onNewsItemClick(val){
      location.href=`/news/${val}`
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
.notifications-base {
  line-height: 1;
  position: fixed;
  z-index: 89000;
  overflow: hidden;
  height: 60px;
  width: 100%;
  max-width: 580px;
  margin: auto;
  top: 44px;
  left: 0;
  right: 0;
  pointer-events: none;
  .message-body {
    width: 100%;
    padding: 8px 20px 10px;
    opacity: 0;
    background: rgba(255,255,255,0.8);
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);
    transform: translate(0, -100%);
    transition: transform 300ms ease-out 0s, opacity 600ms ease-out 100ms;
    .message {
      display: inline-block;
      width: 100%;
      color: $col_base_black;
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: bottom;
      pointer-events: auto;
      cursor: pointer;
    }
    &.open {
      transform: translate(0,0);
      opacity: 1;
    }
  }
}

.lbl-new {
  display: inline-block;
  color: white;
  background: linear-gradient(86.53deg, #FF7497 21.4%, #CB8BFF 76.64%);
  padding: 4px 6px;
  font-size: 10px;
  border-radius: 5px;
  font-weight: bold;
  margin-right: 8px;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/Notifications.vue